import { FigureVarSettingsDto, isFigureVarSettingsDto } from "./FigureVarSettingsDto";

/**
 * Defines the settings for a regression line type within a figure.
 */
export interface FigureRegressionLineSettingsDto {
  lineType: string;
  parameters: FigureVarSettingsDto[];
}

/**
 * Type guard to check if an object is a FigureRegressionLineSettingsDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the regression line settings shape.
 */
export const isFigureRegressionLineSettingsDto = (
  obj: unknown,
): obj is FigureRegressionLineSettingsDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureRegressionLineSettingsDto;
  if (typeof chkObj.lineType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((parameter) => !isFigureVarSettingsDto(parameter))) {
    return false;
  }
  return true;
};
